module.exports = __webpack_public_path__ + "img/addImage.5ece6514.png";